/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/collapsible/custom-elements';

import { defineCustomElement as defineOsdsCollapsible } from '@ovhcloud/ods-stencil/components/collapsible/custom-elements/osds-collapsible.js';


export const OsdsCollapsible = /*@__PURE__*/ defineContainer<JSX.OsdsCollapsible>('osds-collapsible', defineOsdsCollapsible, [
  'opened',
  'odsCollapsibleToggle'
]);

